import React from 'react';

import { useApi, configApiRef } from '@backstage/core-plugin-api';

import {
  DefaultProviderSettings,
  ProviderSettingsItem,
} from '@backstage/plugin-user-settings';

import GroupIcon from '@mui/icons-material/Group';

import { ktnIdsOIDCAuthApiRef } from '../../apis';

const CustomProviderSettings = () => {
  const configApi = useApi(configApiRef);
  const providersConfig = configApi.getOptionalConfig('auth.providers');
  const configuredProviders =
    (providersConfig === null ? void 0 : providersConfig?.keys()) || [];

  return (
    <>
      {configuredProviders.includes('ktnids') && (
        <ProviderSettingsItem
          apiRef={ktnIdsOIDCAuthApiRef}
          description="Provides authentication towards KTN APIs and identities"
          title="KTN Identity Server"
          icon={GroupIcon}
        />
      )}
      <DefaultProviderSettings configuredProviders={configuredProviders} />
    </>
  );
};

export { CustomProviderSettings };
